import React from "react";

/**
 * VerifiedCheck — Twitter-style blue verification badge shown next to a
 * PRO Player's display name. We treat PRO Players (`user_type === 'pro'`)
 * AND PRO League owners (`plan === 'elite'`) as verified, since the league
 * tier grants player perks too.
 */
export function isProUser(u) {
  if (!u) return false;
  const t = (u.user_type || "").toLowerCase();
  const p = (u.plan || "").toLowerCase();
  return t === "pro" || p === "elite" || p === "pro";
}

export function VerifiedCheck({ user, size = 14, title = "PRO Player · verified", className = "" }) {
  if (!isProUser(user)) return null;
  return (
    <span
      data-testid={user?.user_id ? `verified-check-${user.user_id}` : "verified-check"}
      title={title}
      aria-label={title}
      className={`inline-flex items-center justify-center align-middle ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        aria-hidden="true"
      >
        {/* 8-pointed sunburst — recognizable as the "verified" cue without
            being a literal Twitter trademark. */}
        <path
          fill="#14b8a6"
          stroke="#0099b3"
          strokeWidth="0.6"
          d="M12 1.6l1.85 1.95 2.66-.55.55 2.66 1.95 1.85-1.95 1.85.55 2.66-2.66.55L12 14.4l-1.85-1.95-2.66.55-.55-2.66L4.99 8.5l1.95-1.85-.55-2.66 2.66-.55z"
          transform="translate(0 4)"
        />
        <path
          d="M9 12.5l2 2 4-4"
          fill="none"
          stroke="white"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export default VerifiedCheck;
